import { useId } from "react";
const useFallbackId = (id) => {
  const fallbackId = useId();
  return id || fallbackId;
};
export {
  useFallbackId
};
